import ConfirmAccountOpening from './ConfirmAccountOpeningContainer';

export default ConfirmAccountOpening;
